module.exports = __webpack_public_path__ + "img/calendar-1.82264eea.png";